module.exports = __webpack_public_path__ + "static/media/keepass.app.17fff234.png";